export type RedeemSignupTokenParams = {
  username: string;
  signupToken: string;
  returnUrl?: string;
};

const getFirstParam = (params: URLSearchParams, names: string[]): string | null => {
  for (const name of names) {
    const value = params.get(name);
    if (value) return value;
  }

  return null;
};

export const getRedeemSignupTokenParams = (search: string): RedeemSignupTokenParams | null => {
  const params = new URLSearchParams(search);
  const explicitSignupToken = getFirstParam(params, [
    'signupToken',
    'SignupToken',
    'signup_token',
    'Signup_Token',
  ]);
  const username = getFirstParam(params, [
    'username',
    'Username',
    'UserName',
  ]) ?? getFirstParam(params, [ 'email', 'Email' ]);
  const signupToken = explicitSignupToken ?? (username ? getFirstParam(params, [ 'token', 'Token' ]) : null);

  if (!username || !signupToken) {
    return null;
  }

  const returnUrl = getFirstParam(params, [ 'returnUrl', 'ReturnUrl', 'return_url' ]);

  return {
    username,
    signupToken,
    ...(returnUrl ? { returnUrl } : {}),
  };
};

export const hasConfirmEmailToken = (search: string): boolean => (
  new URLSearchParams(search).has('token')
);
